(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('music-sheet-ibq', {
            parent: 'entity',
            url: '/music-sheet-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicSheet.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/music-sheet/music-sheetsibq.html',
                    controller: 'MusicSheetIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicSheet');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('music-sheet-ibq-detail', {
            parent: 'music-sheet-ibq',
            url: '/music-sheet-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicSheet.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/music-sheet/music-sheet-ibq-detail.html',
                    controller: 'MusicSheetIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicSheet');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MusicSheet', function($stateParams, MusicSheet) {
                    return MusicSheet.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'music-sheet-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('music-sheet-ibq-detail.edit', {
            parent: 'music-sheet-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/music-sheet/music-sheet-ibq-dialog.html',
                    controller: 'MusicSheetIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicSheet', function(MusicSheet) {
                            return MusicSheet.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('music-sheet-ibq.new', {
            parent: 'music-sheet-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/music-sheet/music-sheet-ibq-dialog.html',
                    controller: 'MusicSheetIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                musicSheetFile: null,
                                musicSheetFileContentType: null,
                                editionDate: null,
                                pages: null,
                                comments: null,
                                musicSheetFilePath: null,
                                title: null,
                                arrangement: null,
                                cover: null,
                                duration: null,
                                movements: null,
                                instrumentation: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('music-sheet-ibq', null, { reload: 'music-sheet-ibq' });
                }, function() {
                    $state.go('music-sheet-ibq');
                });
            }]
        })
        .state('music-sheet-ibq.edit', {
            parent: 'music-sheet-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/music-sheet/music-sheet-ibq-dialog.html',
                    controller: 'MusicSheetIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicSheet', function(MusicSheet) {
                            return MusicSheet.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('music-sheet-ibq', null, { reload: 'music-sheet-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('music-sheet-ibq.delete', {
            parent: 'music-sheet-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/music-sheet/music-sheet-ibq-delete-dialog.html',
                    controller: 'MusicSheetIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MusicSheet', function(MusicSheet) {
                            return MusicSheet.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('music-sheet-ibq', null, { reload: 'music-sheet-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
